/**
 * 주소 → 화면 이름·한 줄 설명 (메뉴 정의가 정본). 공용 리스트 머리말(ListPageTemplate)이 큰 제목에 쓴다.
 * 가장 길게 맞는 메뉴 주소를 고른다 — /hr 와 /hr/todo 가 함께 맞으면 /hr/todo.
 */
import { menuSections } from '../constants/menuData';
import { hrMenuSections } from '../constants/hrMenuData';

export interface PageMeta { title: string; description?: string; section?: string }

const ENTRIES: Array<PageMeta & { path: string }> = [
  ...menuSections.flatMap((s) => s.menus.map((m) => ({ path: m.path, title: m.title, description: m.description, section: s.sidebarTitle }))),
  ...hrMenuSections.flatMap((e) => (e.type === 'item'
    ? [{ path: e.path, title: e.title }]
    : e.children.map((c) => ({ path: c.path, title: c.title, section: e.title })))),
];

export function findPageMeta(pathname: string): PageMeta | null {
  const hit = ENTRIES
    .filter((e) => pathname === e.path || pathname.startsWith(`${e.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];
  return hit ? { title: hit.title, description: hit.description, section: hit.section } : null;
}
